import React, { Component } from "react";
import "../assets/css/inspection.css";
import AlertModal from "./AlertModal";
import LogsDropdown from "./LogsDropdown";
import AudioFile from "./audioAlert.mp3";

class Inspection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      hoursLogs: [],
      minutesLogs: [],
      secondsLogs: [],
      dateAndTimeLogs: [],
      hidden: true,
      startClicked: "default-color",
      paused: false,
      alertHidden: true,
      firstHours: 0,
      firstMinutes: 0,
      firstSeconds: 0,
      logsEmpty: true,
    }; //MAIN STATE
  }

  // componentDidUpdate() {
  //   localStorage.setItem("InspectionState", JSON.stringify(this.state));
  // }

  // componentDidMount() {
  //   this.InspectionUpdatedState = JSON.parse(
  //     localStorage.getItem("InspectionState")
  //   );
  //   if (this.InspectionUpdatedState) {
  //     this.setState({
  //       // hoursLogs: this.InspectionUpdatedState.hoursLogs,
  //       // minutesLogs: this.InspectionUpdatedState.minutesLogs,
  //       // secondsLogs: this.InspectionUpdatedState.secondsLogs,
  //       // dateAndTimeLogs: this.InspectionUpdatedState.dateAndTimeLogs,
  //       hidden: this.InspectionUpdatedState.hidden,
  //       startClicked: this.InspectionUpdatedState.startClicked,
  //       paused: this.InspectionUpdatedState.paused,
  //       alertHidden: this.InspectionUpdatedState.alertHidden,
  //       firstHours: this.InspectionUpdatedState.firstHours,
  //       firstMinutes: this.InspectionUpdatedState.firstMinutes,
  //       firstSeconds: this.InspectionUpdatedState.firstSeconds,
  //       logsEmpty: this.InspectionUpdatedState.logsEmpty,

  //       hours: this.InspectionUpdatedState.hours,
  //       minutes: this.InspectionUpdatedState.minutes,
  //       seconds: this.InspectionUpdatedState.seconds,
  //       dateAndTime: this.InspectionUpdatedState.dateAndTime,
  //       theCounter: this.InspectionUpdatedState.theCounter,
  //       isCounting: false,
  //     });
  //   } else {
  //     this.setState({
  //       hoursLogs: [],
  //       minutesLogs: [],
  //       secondsLogs: [],
  //       dateAndTimeLogs: [],
  //       hidden: true,
  //       startClicked: "default-color",
  //       paused: false,
  //       alertHidden: true,
  //       firstHours: 0,
  //       firstMinutes: 0,
  //       firstSeconds: 0,
  //       logsEmpty: true,
  //     });
  //   }
  // }

  render() {
    const {
      hours,
      minutes,
      seconds,
      isCounting,
      startClicked,
      paused,
    } = this.state; //STATE EXTRACTION

    const alertOnInvalidLog = () => {
      if (hours == 0 && minutes == 0 && seconds == 0) {
        alert("Either the hour, minute, or second must be greater than zero!");
        return;
      } else {
        logSetToGreen();
        addHourToLog();
        addMinuteToLog();
        addSecondToLog();
        addDateAndTimeToLog();
        // secondsCountDown();
        stopOnPausedBlinking();
        secondsCountDown();
        handleCounting();
        toggleLogsEmptyDisplay();
      }
    };

    const toggleLogsEmptyDisplay = () => {
      this.setState({ logsEmpty: false });
    };

    const toggleLogsEmptyDisplayForLogsReset = () => {
      this.setState({ logsEmpty: true });
    };

    const alertOnInvalidLogForLogTimerButton = () => {
      if (hours == 0 && minutes == 0 && seconds == 0) {
        alert("Either the hour, minute, or second must be greater than zero!");
        return;
      } else {
        logSetToNeutral();
        addDateAndTimeToLog();
        addHourToLog();
        addMinuteToLog();
        addSecondToLog();
        toggleLogsEmptyDisplay();
      }
    };

    var secondsCountDown = () => {
      const { hours, minutes, seconds } = this.state;

      this.setState(() => ({ seconds: seconds - 1 }));
      this.setState({ isCounting: true });
      if (seconds == 1 && minutes == 0 && hours == 5) {
        this.setState({ startClicked: "red" });
        audioAlert();
        toggleAlert();
        handleAutomaticAlertToggle();
        // addWarningPopsToLogs()
        // addDateAndTimeToLog()
      }
      if (seconds < 1) {
        if (minutes >= 1 || hours >= 1) {
          this.setState({ isCounting: true });
          minutesCountDown();
          this.setState({ seconds: 59 });
        } else {
          this.setState({ hours: "00" });
          this.setState({ minutes: "00" });
          this.setState({ seconds: "00" });
          clearInterval(this.theCounter);
          this.setState({ isCounting: false });
          addHourToLog();
          addMinuteToLog();
          addSecondToLog();
          addDateAndTimeToLog();
        }
      } else if (seconds == 0 && minutes == 0 && hours == 0) {
        clearInterval(this.theCounter);
      }
    };
    var minutesCountDown = () => {
      const { hours, minutes } = this.state;

      if (minutes < 1) {
        hoursCountDown();
        this.setState({ minutes: 59 });
      } else if (minutes < 1 && hours <= 1) {
        this.setState({ minutes: "00" });
      } else {
        this.setState({ minutes: minutes - 1 });
      }
    };
    var hoursCountDown = () => {
      var { hours } = this.state;

      if (hours < 1) {
        this.setState({ hours: "00" });
        this.setState({ minutes: "00" });
        this.setState({ seconds: "00" });
        clearInterval(this.theCounter);
        this.setState({ isCounting: false });
      } else {
        this.setState({ hours: hours - 1 });
      }
    };

    const handleChange = (event) => {
      const { name, value } = event.target;

      if (value > 59 || value < 0) {
        this.setState({ value: 59 });
      } else {
        this.setState({ [name]: value });
        this.setState({ firstMinutes: value });
        this.setState({ firstSeconds: value });
      }
    };
    const handleHoursChange = (event) => {
      const { name, value } = event.target;
      // const { minutes, seconds, hours } = this.state;

      if (value > 1000 || value < 0) {
        this.setState({ value: 1000 });
      } else {
        this.setState({ hours: value });
        this.setState({ firstHours: value });
      }
    };

    var handleCounting = () => {
      this.theCounter = setInterval(secondsCountDown, 1000);
    };

    const handleAutomaticAlertToggle = () => {
      this.automaticToggler = setInterval(toggleAlert, 1500);
     this.automaticTogglerAudio = setInterval(audioAlert, 3000);
    };

    const automaticOnPausedBlinking = () => {
      this.onPausedBlinking = setInterval(togglePauseForBlinking, 800);
    };

    const stopOnPausedBlinking = () => {
      clearInterval(this.onPausedBlinking);
    };

    const audioAlert = () => {
      var audio = new Audio(AudioFile)
      audio.play()
    }

    const toggleAlert = () => {

      this.setState({ alertHidden: !this.state.alertHidden });
    };

    const handleReset = () => {
      this.setState({ hours: "00" });
      this.setState({ minutes: "00" });
      this.setState({ seconds: "00" });
      this.setState({ isCounting: false });
    };
    const handlePause = () => {
      clearInterval(this.theCounter);
      this.setState({ isCounting: false });
    };

    const handleResetConfirmation = () => {
      handleReset();
      stopOnPausedBlinking();
      togglePauseToFalse();
    };

    const stopAutoAlert = () => {
      clearInterval(this.automaticToggler);
    };

    const stopAutoAlertAudio = () => {
      clearInterval(this.automaticTogglerAudio);
    };

    const logReset = () => {
      this.setState({ hoursLogs: [] });
      this.setState({ minutesLogs: [] });
      this.setState({ secondsLogs: [] });
      this.setState({ dateAndTimeLogs: [] });
      toggleLogsEmptyDisplayForLogsReset();
    };

    const toggleLogsOn = () => {
      this.setState({ hidden: false });
    };
    const toggleLogsOff = () => {
      this.setState({ hidden: true });
    };

    const setDateAndTime = () => {
      this.setState({ dateAndTime: new Date().toLocaleString("en-NG") });
    };

    const logSetToGreen = () => {
      // console.log(this.state.startClicked);
      this.setState({ startClicked: "green" });
    };
    const logSetToRed = () => {
      this.setState({ startClicked: "red" });
    };
    const logSetToNeutral = () => {
      this.setState({ startClicked: "" });
    };

    const addHourToLog = () => {
      var hoursLogs = this.state.hoursLogs.concat([
        startClicked == "green" ? (
          <span className="color-green">{this.state.hours}</span>
        ) : startClicked == "red" ? (
          <span className="color-red">{this.state.hours}</span>
        ) : (
          <span className="default-color">{this.state.hours}</span>
        ),
      ]);

      this.setState({ hoursLogs });
    };
    const addMinuteToLog = () => {
      var minutesLogs = this.state.minutesLogs.concat([
        startClicked == "green" ? (
          <span className="color-green">{this.state.minutes}</span>
        ) : startClicked == "red" ? (
          <span className="color-red">{this.state.minutes}</span>
        ) : (
          <span className="default-color">{this.state.minutes}</span>
        ),
      ]);

      this.setState({ dateAndTime: new Date().toLocaleString("en-NG") });
      this.setState({ minutesLogs });
    };
    const addSecondToLog = () => {
      var secondsLogs = this.state.secondsLogs.concat([
        startClicked == "green" ? (
          <span className="color-green">{this.state.seconds}</span>
        ) : startClicked == "red" ? (
          <span className="color-red">{this.state.seconds}</span>
        ) : (
          <span className="default-color">{this.state.seconds}</span>
        ),
      ]);

      this.setState({ secondsLogs });
    };
    const addDateAndTimeToLog = () => {
      var dateAndTimeLogs = this.state.dateAndTimeLogs.concat([
        startClicked == "green" ? (
          <span className="color-green">{this.state.dateAndTime}</span>
        ) : startClicked == "red" ? (
          <span className="color-red">{this.state.dateAndTime}</span>
        ) : (
          this.state.dateAndTime
        ),
      ]);
      this.setState({ dateAndTimeLogs });
    };
    const togglePauseForBlinking = () => {
      this.setState({ paused: !this.state.paused });
      // console.log("paused");
    };

    const togglePauseToFalse = () => {
      this.setState({ paused: false });
      // console.log("paused");
    };

    const confirmDialog = () => {
      window.confirm("Click OK to reset, or cancel to go back.") &&
        handleResetConfirmation();
    };

    return (
      <div>
        <LogsDropdown
          {...this.state}
          // {...this.props}
          addHourToLog={addHourToLog}
          setDateAndTime={setDateAndTime}
          alertOnInvalidLogForLogTimerButton={
            alertOnInvalidLogForLogTimerButton
          }
          addDateAndTimeToLog={addDateAndTimeToLog}
          logSetToNeutral={logSetToNeutral}
          logSetToRed={logSetToRed}
          addMinuteToLog={addMinuteToLog}
          addSecondToLog={addSecondToLog}
          logReset={logReset}
          toggleLogsEmptyDisplay={toggleLogsEmptyDisplay}
          toggleLogsEmptyDisplayForLogsReset={
            toggleLogsEmptyDisplayForLogsReset
          }
        />

        <AlertModal
          {...this.state}
          toggleAlert={toggleAlert}
          stopAutoAlert={stopAutoAlert}
          addDateAndTimeToLog={addDateAndTimeToLog}
          stopAutoAlertAudio = {stopAutoAlertAudio}
        />

        <header className="masthead" id="page-top">
          <div id="container">
            {/* <div className="masthead-subheading "> */}
            {isCounting == false ? (
              <p id="hour-label" className="label">
                Input Hrs
              </p>
            ) : (
              <p id="hour-label" className="label">
                Hrs Left
              </p>
            )}
            {isCounting == false ? (
              <p id="min-label" className="label">
                Input Mins
              </p>
            ) : (
              <p id="min-label" className="label">
                Mins Left
              </p>
            )}
            {isCounting == false ? (
              <p id="sec-label" className="label">
                Input Secs
              </p>
            ) : (
              <p id="sec-label" className="label">
                Secs Left
              </p>
            )}
            {isCounting ? (
              <span style={{ color: "#079707" }} id="hour" className="time">
                {hours}
              </span>
            ) : (
              <input
                type="number"
                // name="hours"
                id="hour"
                min="00"
                max="10000"
                // placeholder="00"
                value={hours}
                className={"time " + (paused ? "hide" : "")}
                onChange={handleHoursChange}
              />
            )}{" "}
            <p id="p1" className="semicolon">
              :
            </p>
            {isCounting ? (
              <span style={{ color: "#079707" }} id="minute" className="time">
                {minutes}
              </span>
            ) : (
              <input
                onChange={handleChange}
                name="minutes"
                type="number"
                id="minute"
                min="00"
                value={minutes}
                max="60"
                className={"time " + (paused ? "hide" : "")}
              />
            )}
            <p id="p2" className="semicolon">
              :
            </p>
            {isCounting ? (
              <span style={{ color: "#079707" }} id="sec" className="time">
                {seconds}
              </span>
            ) : (
              <input
                onChange={handleChange}
                name="seconds"
                type="number"
                id="sec"
                min="00"
                value={seconds}
                max="60"
                className={"time " + (paused ? "hide" : "")}
              />
            )}
            
          </div>

          {isCounting ? (
            <button
              onMouseDown={() => {
                logSetToRed();
                setDateAndTime();
              }}
              onMouseOver={() => {
                logSetToRed();
                setDateAndTime();
              }}
              //   disabled={isCounting == false}
              onClick={() => {
                // togglePauseForBlinking();
                automaticOnPausedBlinking();
                logSetToRed();
                handlePause();
                addHourToLog();
                addMinuteToLog();
                addSecondToLog();
                addDateAndTimeToLog();
              }}
              className="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
            >
              PAUSE
            </button>
          ) : (
            <button
              onMouseDown={() => {
                logSetToGreen();
                setDateAndTime();
              }}
              onMouseOver={() => {
                logSetToGreen();
                setDateAndTime();
              }}
                onClick={() => {
                  // audioAlert();
                alertOnInvalidLog();

                // console.log(this.state.startClicked);
              }}
              className={
                "btn btn-primary btn-xl text-uppercase js-scroll-trigger"
              }
            >
              START
            </button>
          )}
          <button
            onMouseDown={() => {
              logSetToRed();
              setDateAndTime();
            }}
            onMouseOver={() => {
              logSetToRed();
              setDateAndTime();
            }}
            onClick={
              () => {
                addDateAndTimeToLog();
                addHourToLog();
                addMinuteToLog();
                addSecondToLog();
                confirmDialog();
              }
              //   this.resetConfirmation =window.confirm('OK to reset, or cancel to continue.'),
              //     this.resetConfirmation ?      () => {

              //       handleReset();
              // stopOnPausedBlinking();

              //     } : null
            }
            className="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
          >
            RESET
          </button>
          {/* {this.state.logsHidden ? ( */}
          {this.state.hidden ? (
            <button
              onClick={toggleLogsOn}
              // onClick={() => {
              //   this.props.showLogs();
              // }}
              className="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
            >
              SHOW LOGS
            </button>
          ) : (
            <button
              onClick={toggleLogsOff}
              // onClick={() => {
              //   this.props.hideLogs();
              // }}
              className="btn btn-primary btn-xl text-uppercase js-scroll-trigger"
            >
              HIDE LOGS
            </button>
          )}
        </header>
      </div>
    );
  }
}

export default Inspection;
